const colors = {

    INPUT_FEEDBACK: '#4A4A4A',

}

module.exports = {
    colors
}